import React from 'react';

import { SelectTextField } from '@lumapps/combobox/components/SelectTextField';
import { useDataAttributes } from '@lumapps/data-attributes';
import { useGetSegmentAction } from '@lumapps/groups/hooks/useGetSegmentAction';
import { Group } from '@lumapps/groups/types';

export interface SegmentMoreInfoProps {
    // The group (actually a segment) object for which to display more information.
    group: Group;
    /** scope for tracking purposes */
    scope: string;
}

/**
 * SegmentMoreInfo component displays additional information about a group segment.
 * It uses a popover to show segment-specific content when triggered.
 *
 * @param {SegmentMoreInfoProps} props - The props for the component.
 * @returns {JSX.Element} The rendered component.
 */
export const SegmentMoreInfo: React.FC<SegmentMoreInfoProps> = ({ group, scope }) => {
    const [isPopoverOpen, setIsPopoverOpen] = React.useState<boolean>(false);
    const { get } = useDataAttributes(scope);
    const { SegmentInformationContent } = useGetSegmentAction({
        group,
        isOpen: isPopoverOpen,
        setIsOpen: setIsPopoverOpen,
    });

    return (
        <SelectTextField.OptionMoreInfo
            onToggle={setIsPopoverOpen}
            buttonProps={get({ element: 'info', action: group.id })}
        >
            {SegmentInformationContent}
        </SelectTextField.OptionMoreInfo>
    );
};
